import { IndicatorActionTypes, IndicatorActions } from './indicator.actions';

// export interface State {
//   active: number;
//   actionsInProgress: any[];
// }
// const initialState: State = {
//   active: 0,
//   actionsInProgress: []
// };

export const CART_STORE_NAME = 'cart';

export const initialState: string[] = [];

export function indicatorReducer(state = initialState, action: IndicatorActions) {
  switch (action.type) {
    case IndicatorActionTypes.SHOW: {
      for (const item of state) {
        if (item === action.payload) {
          return state;
        }
      }
      return [...state, action.payload];
    }
    case IndicatorActionTypes.HIDE:
      return state.filter((item) => !action.payload.includes(item));
    case IndicatorActionTypes.HIDE_ALL:
      return [];
    default:
      return state;
  }
}

// export const isLoadingIndicatorActive = (state: State) => state.active;
